export const NAME = 'artElements';
